import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as transactionService from '../services/transectionService';

// Async thunks
export const fetchTransectionListThunk = createAsyncThunk(
  'transection/fetchTransectionList',
  async ({type,id}, { rejectWithValue }) => {
    try {
      return await transactionService.fetchTansectionList({type,id});
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);




const transectionSlice = createSlice({
  name: 'transection',
  initialState: {
    data: {},
    data1: {},
    status: 'idle',
    uniqueCode: "",
    error: null,
    submitted: false, // to track if the form was submitted
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
    resetSubmission(state) {
      state.submitted = false;
      state.status = 'idle';
    },
     clearUniqueCode: (state) => {
      state.uniqueCode = null;
    },
  },
  extraReducers: builder => {
    builder
      // fetchUsers
      .addCase(fetchTransectionListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTransectionListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(fetchTransectionListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })

  }
});

export const { clearError, resetSubmission,clearUniqueCode } = transectionSlice.actions;

export default transectionSlice.reducer;
